module.exports = __webpack_public_path__ + "img/boy.a8074ecd.png";